module.exports = __webpack_public_path__ + "img/bell.d059396c.svg";